// TGCW a.k.a. The Great Cookie Wall

// -------------------------------------------

// Global boolean for CSP injection
const tgcw_csp = false;

// Make it possible to retrieve some cookie values using vanilla JS in order to allow CSP meta creation - At this stage the js-cookie lib. might not be loaded
const init_cookies = document.cookie.split( ';' ).reduce(( cookieObject, cookie ) => {
    const [name, value] = cookie.trim().split( '=' ).map( decodeURIComponent );
    cookieObject[name] = value;
    return cookieObject;
}, {});

// CSP injection enabled
let tgcw_csp_meta;
if ( tgcw_csp ) {
    // First things first: Dynamically modify the page's Content Security Policy (CSP) to block the loading of external scripts, images, iframes, and style links - Using vanilla JS
    // TODO: CHECK IF THIS BREAKS STUFF IN A REAL ENVIRONMENT!!!
    // NOTE: Could cause conflicts when CSP was already set by HTTP headers!
    // If there is no "tgcw_mandatory" cookie and no CPS meta present, create a CSP meta
    if ( !! document.querySelector( 'meta[http-equiv="Content-Security-Policy"]' ) === false && init_cookies['tgcw_external'] !== 'accept' ) {
        // Prepare the CSP meta
        tgcw_csp_meta           = document.createElement( 'meta' );
        tgcw_csp_meta.setAttribute( 'id', 'tgcw_csp' ); // Add ID to the CSP meta tag, so it can be removed later
        tgcw_csp_meta.httpEquiv = 'Content-Security-Policy';
        tgcw_csp_meta.content   = "default-src 'self'; frame-src 'none'; script-src 'self'; img-src 'self'; link-src 'self'; style-src 'self';";
        // Inject the CSP meta as the first element in the <head>
        document.head.insertBefore( tgcw_csp_meta, document.head.firstChild );
    } else if ( !! document.querySelector( 'meta[http-equiv="Content-Security-Policy"]' ) === true && init_cookies['tgcw_external'] !== 'accept' ) {
        // TODO: Figure out some script to analyze the current parameters reliably and move on from there ...
        console.log( 'Found CSP meta!' );
    }

    // Additionally add cache control meta to prevent caching of images
    // If there is no "tgcw_mandatory" cookie and no cache control meta present, create cache meta
    if ( !! document.querySelector( 'meta[http-equiv="Cache-Control"]' ) === false && init_cookies['tgcw_external'] !== 'accept' ) {
        // Prepare cache meta
        tgcw_cache_meta             = document.createElement('meta');
        tgcw_cache_meta.setAttribute('id', 'tgcw_cache'); // Add ID to the cache control meta tag, so it can be removed later
        tgcw_cache_meta.httpEquiv   = 'Cache-Control';
        tgcw_cache_meta.content     = 'no-cache';
        // Inject the cache meta in the <head>
        document.head.appendChild( tgcw_cache_meta );
    } else {
        // TODO: Figure out some script to analyze the current parameters reliably and move on from there ...
        console.log( 'Found cache meta!' );
    }

    // Additionally add pragma meta to prevent caching of images
    // If there is no "tgcw_mandatory" cookie and no pragma meta present, create pragma meta
    if ( !! document.querySelector( 'meta[http-equiv="Pragma"]' ) === false && init_cookies['tgcw_external'] !== 'accept' ) {
        // Prepare cache meta
        tgcw_pragma_meta             = document.createElement('meta');
        tgcw_pragma_meta.setAttribute('id', 'tgcw_pragma'); // Add ID to the pragma meta tag, so it can be removed later
        tgcw_pragma_meta.httpEquiv   = 'Pragma';
        tgcw_pragma_meta.content     = 'no-cache';
        // Inject the cache meta in the <head>
        document.head.appendChild( tgcw_pragma_meta );
    } else {
        // TODO: Figure out some script to analyze the current parameters reliably and move on from there ...
        console.log( 'Found pragma meta!' );
    }
}

// -------------------------------------------

// Globals
// Main TGCW container / content
const tgcw_container        = jQuery( '.tgcw_container' );
const tgcw_content          = jQuery( '.tgcw_content' );
// TGCW data dumps
let tgcw_dump		        = [];
let tgcw_illegal_urls;
// CSP injection enabled
if ( tgcw_csp ) {
    tgcw_illegal_urls = [];
}
// Prefixed ext. platforms to trigger on
let tgcw_ref_analytics      = 'google|googletagmanager|google-analytics|analytics|statcounter';
let tgcw_ref_video		    = 'youtube|vimeo|odysee|bitchute|rumble|ugetube|newtube';
let tgcw_ref_social		    = 'x|twitter|facebook|instagram';
let tgcw_ref_ext		    = 'cdnjs';
let tgcw_ref_misc		    = 'linkedin|xing|monsterboard';
// Group all ext. platforms into single trigger
let tgcw_trigger		    = tgcw_ref_analytics + '|' + tgcw_ref_video + '|' + tgcw_ref_social + '|' + tgcw_ref_ext + '|' + tgcw_ref_misc;
let tgcw_ref_replace        =   {
                                    'platform.twitter': 'twitter',
                                    'player.vimeo': 'vimeo'
                                };
// Prompt the panel on init state
let tgcw_prompt 		= true;
// Show toggles or buttons on cookie wall
let tgcw_buttons		= true;
let tgcw_txt_accept;
if ( typeof TEXT_COOKIE_WALL_ACCEPT_BUTTON !== 'undefined' && TEXT_COOKIE_WALL_ACCEPT_BUTTON.length ) {
    tgcw_txt_accept = TEXT_COOKIE_WALL_ACCEPT_BUTTON;
} else {
    tgcw_txt_accept = 'Accept';
}
let tgcw_txt_reject;
if ( typeof TEXT_COOKIE_WALL_REJECT_BUTTON !== 'undefined' && TEXT_COOKIE_WALL_REJECT_BUTTON.length ) {
    tgcw_txt_reject = TEXT_COOKIE_WALL_REJECT_BUTTON;
} else {
    tgcw_txt_reject = 'Reject';
}
// Wall text replace: [platform]
// TODO: Enhance with option to have custom text per platform in the wall?
// Note: The parts in brackets are pre-defined strings which will be replaced by tgcw with variable values.
let tgcw_text_wall;
if ( typeof TEXT_COOKIE_WALL_DEFAULT !== 'undefined' && TEXT_COOKIE_WALL_DEFAULT.length ) {
    tgcw_text_wall = TEXT_COOKIE_WALL_DEFAULT;
} else {
    tgcw_text_wall = 'This content is hosted externally by <b>[platform]</b>. By allowing the external content you accept the terms and conditions of <b>[platform]</b>.';
}
// Tag(s) trigger selector
// TODO: Make optional to check HTML <head> as well (based on ID reference)? - Might destroy the page though!!
// TODO: Extend with embedded objects?
// let elem_trigger        = jQuery( 'body' ).find( 'iframe, script, img, link' );
let elem_trigger        = jQuery( 'body' ).find( 'iframe, script, link' );
let has_trigger         = elem_trigger.length;
// IIFE - async to also support older browsers
// NOTE: This is a closed / private scope
( async () => {
    // Listen to DOM content load
    document.addEventListener( 'DOMContentLoaded', function() {
        // CSP injection enabled
        let curr_csp;
        let curr_csp_content;
        let curr_csp_update;
        if ( tgcw_csp ) {
            // CSP vars
            curr_csp = jQuery( 'head meta[http-equiv="Content-Security-Policy"]' );
            curr_csp_content = curr_csp.attr( 'content' );
        }
        // Counter to set the target id
        let id_number   = 1;
        // Prep. source / content
        let this_src;
        let this_content;
        // Are there any tags to trigger on?
        if ( has_trigger && typeof has_trigger !== 'undefined' ) {
            // Loop through all illegal elements
            jQuery.each( elem_trigger, function() {
                // Some vars
                let _this           = jQuery( this );
                let this_tag        = this.tagName.toLowerCase();
                // Get the (source) URL of the element
                if ( this_tag && typeof this_tag !== 'undefined' ) {
                    switch( this_tag ) {
                        // case 'img':
                        //     this_src            = _this.attr( 'src' );
                        //     this_content        = false;
                        //     break;
                        case 'iframe':
                            this_src            = _this.attr( 'src' );
                            this_content        = false;
                            break;
                        case 'script':
                            if ( _this.attr( 'src' ) ) {
                                this_src        = _this.attr( 'src' );
                                this_content    = false;
                            } else {
                                // Skip this one ...
                                // TODO: Check snippet content for external URLs
                                // this_src = false;
                                // this_content    = _this.text();
                                return;
                            }
                            break;
                        case 'link':
                            if ( _this.attr( 'href' ) ) {
                                this_src        = _this.attr( 'href' );
                                this_content    = false;
                            }
                            break;
                    }
                }
                // ----------------------------
                // Check for shorthand url prefix "//" and replace by secure full prefix "https://"
                this_src = tgcw_replace_short( this_src );
                // ----------------------------
                // Replace TLD first based on "tgcw_ref_replace"
                this_src = tgcw_replace_tld( this_src, tgcw_ref_replace, true );
                // ----------------------------
                let this_ref        = tgcw_tld( this_src );
                let this_platform 	= this_ref;
                // Start the id counter ...
                let this_id         = 'trigger_' + id_number++;
                // Wall text
                let wall_text_parse = tgcw_text_wall.replaceAll( '[platform]', ucfirst( this_platform ));
                let wall_text		= '<p class="tgcw_text">' + wall_text_parse + '</p>';
                // Wall actions
                let wall_actions	= tgcw_actions( tgcw_buttons, this_id, this_platform );
                let great_wall		= '<section id="' + this_id + '" class="tgcw_section tgcw_wall ' + this_platform + '">' + wall_text + wall_actions + '</section>';
                let great_block		= '<div id="' + this_id + '" class="tgcw_div tgcw_block ' + this_platform + '"></div>';
                // Check if platform cookie has been set
                let has_cookie		= tgcw_cookie( 'get', this_ref );
                let this_tpl_bool   = false;
                // Reject if source has no cookie and when hosted from another domain or if it matches anything from the predefined string "tgcw_trigger" = illegal content
                if ( ! has_cookie && (( tgcw_tld( this_src ) !== tgcw_tld() || tgcw_match_exact( this_ref ) === true ) && ( this_src.indexOf( 'http://' ) === 0 || this_src.indexOf( 'https://' ) === 0 ) && this_ref !== 'localhost' )) {
                    // CSP injection enabled
                    let illegal_url;
                    if ( tgcw_csp ) {
                        // Get domain name first
                        illegal_url = this_src.match( /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/ )[1];
                        // Dump newly found illegal domain name into the illegal URLs array
                        tgcw_illegal_urls.push( illegal_url );
                    }
                    // Destroy elements, return a great wall or block
                    // Empty source / contents first before replacing it, just to be sure ...
                    if ( this_tag && typeof this_tag !== 'undefined' ) {
                        switch( this_tag ) {
                            // case 'img':
                            //     // Check if it's an external include
                            //     if ( _this.attr( 'src' ) ) {
                            //         // _this.attr( 'src', '' );
                            //         _this.removeAttr( 'src' );
                            //         _this.replaceWith( great_wall );
                            //     }
                            //     break;
                            case 'iframe':
                                // _this.attr( 'src', '' );
                                _this.removeAttr( 'src' );
                                _this.contents().html( '' );
                                _this.replaceWith( great_wall );
                                break;
                            case 'script':
                                // Check if it's an external include
                                if ( _this.attr( 'src' ) ) {
                                    // _this.attr( 'src', '' );
                                    _this.removeAttr( 'src' );
                                    _this.replaceWith( great_block );
                                } else {
                                    // NOTE: Here we could detect snippet contents for further processing ...
                                    // Skip this one
                                    return;
                                }
                                break;
                            case 'link':
                                // Check if it's an external include
                                if ( _this.attr( 'href' )) {
                                    // _this.attr( 'href', '' );
                                    _this.removeAttr( 'href' );
                                    _this.replaceWith( great_block );
                                }
                                break;
                            default:
                                return false;
                        }
                    }
                    // Dump data into array for later processing
                    tgcw_dump.push({ 'trigger_id': this_id, 'trigger_tag': this_tag, 'trigger_src': this_src, 'trigger_platform': this_ref, 'trigger_content': this_content });
                    // Inject setting box template
                    tgcw_inject_settings( this_ref );
                } else if ( has_cookie && Cookies.get( 'tgcw_' + this_ref ) === 'accept' && this_ref !== 'localhost' ) {

                    // If cookie was found and accepted, boolean will be true = "checked"
                    this_tpl_bool = true;
                    tgcw_rebuild( this_id );
                    // Inject setting box template
                    tgcw_inject_settings( this_ref, this_tpl_bool );
                }
            });
            // CSP injection enabled
            if ( tgcw_csp ) {
                // TODO: Test timings of this solution?
                // Reference content: "default-src 'self'; frame-src 'none'; script-src 'self'; img-src 'self'; link-src 'self'; style-src 'self';"
                // Prepare the new CSP tag
                curr_csp_update = curr_csp_content.replace( "default-src 'self';", "default-src 'self' 'none' " + tgcw_illegal_urls.map( url => url ).join( ' ' ) + ';' );
                jQuery( 'meta[http-equiv="Content-Security-Policy"]' ).attr( 'content', curr_csp_update );
            }
        } else {
            // No matching trigger(s) present, so we can now remove all the illegal content CSP restrictions, clean arrays, etc. when document is ready;
            jQuery( document ).ready( function() {
                // Empty arrays
                tgcw_dump = [];
                // CSP injection enabled
                if ( tgcw_csp ) {
                    tgcw_illegal_urls = [];
                    // Remove CSP meta
                    jQuery( 'head > #tgcw_csp' ).remove();
                }
            });
        }
        // Show panel if no mandatory cookie has been set (prompt needs to be true)
        if (( Cookies.get( 'tgcw_mandatory' ) === -1 || typeof Cookies.get( 'tgcw_mandatory' ) === 'undefined' ) && ( tgcw_prompt && typeof tgcw_prompt !== 'undefined' )) {
            tgcw_recall( true );
        }
    });

    // Page reload
    function tgcw_reload() {
        setTimeout(() => {
            location.reload();
        }, 250 );
    }

    // Recall / hide TGCW panel
    function tgcw_recall( bool = false ) {
        if ( bool && typeof bool !== 'undefined' ) {
            // Init panel based on cookies (if any)
            tgcw_panel_process( 'init' );
            // Add small deferred delay
            tgcw_wait( 150 ).then( function() {
                tgcw_container.addClass( 'active' );
            });
        } else {
            tgcw_container.removeClass( 'active' );
        }
    }

    // Load a deferred promise
    function tgcw_wait( ms ) {
        let deferred = jQuery.Deferred();
        // Set timeout
        setTimeout( function() {
            deferred.resolve()
        }, ms );
        return deferred.promise();
    }

    // Use regex to replace dashes or underscores with spaces and capitalize the first letter of each word
    function tgcw_beautystring( str ) {
        str = str.replace( /[_-]\w|\b\w/g, function( match ) {
            return match.toUpperCase();
        }).replace( /[_-]/g, ' ' );
        // Look at that beautified string!
        return str;
    }

    // Check if the url prefix is "shorthanded" and replace it to a full url prefix if so
    function tgcw_replace_short( url ) {
        // Regular expression to check if the string starts with //
        let regex = /^\/\//;
        // Check if the URL starts with //
        if ( regex.test( url )) {
            // Replace // with https://
            url = url.replace( regex, 'https://' );
            // console.log( url );
        }
        // Return full url prefix
        return url;
    }

    // Replace parts of a URL, to set the correct TLD (top level domain) based on array in order to parse the TLD without any headaches, PSL-tricks, etc
    // TODO: Expand this with other known domain names
    function tgcw_replace_tld( url, arr, bool ) {
        // Iterate through the replacement array and replace stuff accordingly ...
        jQuery.each( arr, function( key, value ) {
            if ( bool && typeof bool !== 'undefined' ) {
                url = url.replace( new RegExp( key, 'g' ), value );
            } else {
                url = url.replace( new RegExp( value, 'g' ), key );
            }
        });
        return url;
    }

    // Get TLD (top level domain) name = host
    function tgcw_tld( src ) {
        let this_domain;
        // Check for correct source
        if ( src && typeof src !== 'undefined' ) {
            this_domain = src;
        } else {
            this_domain = window.location.hostname;
        }
        // Strip double domain extensions like ".co.uk", etc
        // NOTE: Can cause subdomain issues if not solved beforehand!
        if ( this_domain.match( new RegExp( /\.[a-z]{2,3}\.[a-z]{2}$/i ))) {
            this_domain = this_domain.replace( new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i ),'' );
        }
        // Strip prefixes http(s) / www
        this_domain = this_domain.replace( /^(?:https?:\/\/)?(?:www\.)?/i, '' ).split( '/' )[0];
        // Strip everything else
        this_domain = this_domain.split( '.' )[0];
        return this_domain;
    }

    // Check if there is an exact match based on the ref value against the predefined trigger list
    function tgcw_match_exact( ref_exact ) {
        // Return true if there's a match
        let pattern = new RegExp( `(^|\\|)${ref_exact}(\\||$)` );
        return tgcw_trigger.match( pattern ) !== null;
    }

    // Wall actions, return either buttons or a toggle
    function tgcw_actions( buttons, id, platform ) {
        let tgcw_actions;
        if ( buttons && typeof buttons !== 'undefined' ) {
            let tgcw_button_allow 	= '<button class="js_tgcw_action tgcw_btn medium" data-type="button" data-val="accept" data-id="' + id + '" data-ref="' + platform + '">' + tgcw_txt_accept + '</button>';
            // let tgcw_button_reject 	= '<button class="js_tgcw_action tgcw_btn medium" data-type="button" data-val="reject" data-id="' + id + '" data-ref="' + platform + '">' + tgcw_txt_reject + '</button>';
            //     tgcw_actions 		= '<div class="tgcw_actions buttons" data-action_trigger="buttons">' + tgcw_button_allow + tgcw_button_reject + '</div>';
            tgcw_actions 		= '<div class="tgcw_actions buttons" data-action_trigger="buttons">' + tgcw_button_allow + '</div>';
        } else {
            let tgcw_checkbox 		= '<input class="js_tgcw_action tgcw_checkbox" type="checkbox" data-type="checkbox" data-id="' + id + '" data-ref="' + platform + '" />';
            let tgcw_toggle_wrapper	= '<label class="tgcw_toggle_box">' + tgcw_checkbox + '<span class="tgcw_toggle round"></span></label>';
                tgcw_actions 		= '<div class="tgcw_actions toggle" data-action_trigger="toggle">' + tgcw_toggle_wrapper + '</div>';
        }
        return tgcw_actions;
    }

    // Rebuild elements
    // TODO: Expand with "embed"?
    function tgcw_rebuild( id ) {
        if ( id && typeof id !== 'undefined' ) {
            // Loop through the TGCW dump and use correct "recovery method" based on HTML tag
            jQuery.each( tgcw_dump, function() {
                if ( this.trigger_id === id ) {
                    let this_target	= jQuery( '#' + id );
                    let this_tag    = this.trigger_tag;
                    let this_src    = this.trigger_src;
                    // ----------------------------
                    // Replace TLD first based on "tgcw_ref_replace"
                    this_src = tgcw_replace_tld( this_src, tgcw_ref_replace, false );
                    // ----------------------------
                    let tgcw_html;
                    // Recover stuff ...
                    if ( this_tag && typeof this_tag !== 'undefined' ) {
                        switch( this_tag ) {
                            // case 'img':
                            //     tgcw_html = '<img src="' + this_src + '" alt="' + this.trigger_platform + '" />';
                            //     break;
                            case 'iframe':
                                tgcw_html = '<iframe class="tgcw_iframe" src="' + this_src + '"></iframe>';
                                break;
                            case 'script':
                                tgcw_html = '<script type="text/javascript" src="' + this_src + '"></script>';
                                break;
                            case 'link':
                                tgcw_html = '<link rel="stylesheet" href="' + this_src + '">';
                                break;
                            default:
                                return false;
                        }
                    }
                    // Return tag / html
                    return this_target.replaceWith( tgcw_html );
                }
            });
        }
    }

    // Inject external settings box template
    // NOTE: This will be injected into the "externals" settings box for each found trigger
    function tgcw_inject_settings( ref, bool ) {
        if ( ref && typeof ref !== 'undefined' ) {
            let this_selector   = tgcw_content.find( '.tgcw_settings_box[data-block="external"] .tgcw_specs_text' );
            let append_location = this_selector.find( '> .text' );
            let has_sub         = this_selector.find( '> .tgcw_settings_box.sub' );
            let has_duplicate   = this_selector.find( '> .tgcw_settings_box.sub .tgcw_checkbox[data-ref="' + ref + '"]' );
            let last_sub        = this_selector.find( '> .tgcw_settings_box.sub:last-of-type' );
            let is_checked      = '';
            // Mark as checked?
            if ( bool && typeof bool !== 'undefined' ) {
                is_checked = 'checked';
            }
            // The actual settings box TPL
            let inject_tpl      =   '<div class="tgcw_settings_box sub">' +
                                        '<div class="tgcw_actions toggle" data-action_trigger="toggle">' +
                                            '<label class="tgcw_toggle_box">' +
                                                '<input class="js_tgcw_toggle tgcw_action tgcw_checkbox" type="checkbox" data-type="checkbox" data-ref="' + ref + '" data-cookie="tgcw_' + ref + '" autoComplete="off" ' + is_checked + '>' +
                                                '<span class="tgcw_toggle round"></span>' +
                                            '</label>' +
                                            '<div class="tgcw_toggle_text">' + tgcw_beautystring( ref ) + '</div>' +
                                        '</div>' +
                                    '</div>';
            // Inject it, but don't make duplicates ...
            // TODO: See if duplicate part can be removed to make it more dynamic
            if ( ! has_duplicate.length ) {
                if ( has_sub.length ) {
                    last_sub.after( inject_tpl );
                } else {
                    append_location.after( inject_tpl );
                }
            } else {
                return false;
            }
        }
    }

    // Process the panel checkboxes (after hitting main panel action)
    // TODO: Check if it's needed to set params like duration, domain, etc? (see lib.)
    function tgcw_panel_process( task ) {
        // console.log( 'Processing panel ...' );
        let parent_box      = tgcw_content.find( '.tgcw_settings_box:not( .sub )' );
        let tar_checkbox    = tgcw_content.find( '.tgcw_settings_box :checkbox' );
        // Go ahead ...
        if ( task && typeof task !== 'undefined' ) {
            // Go ahead ...
            switch( task ) {
                // Init panel and toggle corresponding settings boxes
                case 'init':
                    // Toggle all checkboxes based on cookie
                    tar_checkbox.each( function() {
                        let _this       = jQuery( this );
                        let this_parent = _this.closest( '.tgcw_specs' );
                        let this_ref    = _this.attr( 'data-ref' );
                        let curr_cookie = Cookies.get( 'tgcw_' + this_ref );
                        // Found cookie, set corresponding checkbox
                        if ( typeof curr_cookie !== 'undefined' && curr_cookie === 'accept' ) {
                            tgcw_content.find( 'input[data-cookie="' + 'tgcw_' + this_ref + '"]').prop( 'checked', true );
                            // Open parent settings box
                            this_parent.find( '> .tgcw_content_toggle' ).prop( 'checked', true );
                        }
                    });
                    // See if the main toggle is also checked when all sub settings are
                    parent_box.each( function() {
                        let _this                   = jQuery( this );
                        let this_main_toggle        = _this.find( ':checkbox[data-toggle="main"]' );
                        let this_main_checked       = this_main_toggle.attr( 'checked' );
                        let count_sub_checkboxes    = _this.find( '.tgcw_settings_box.sub :checkbox' ).length;
                        let checked_sub_checkboxes  = _this.find( '.tgcw_settings_box.sub :checkbox:checked' ).length;
                        // Check the main toggle
                        if ( ! this_main_checked && typeof this_main_checked === 'undefined' ) {
                            // All sub settings are checked
                            if ( count_sub_checkboxes && count_sub_checkboxes === checked_sub_checkboxes ) {
                                this_main_toggle.prop( 'checked', true );
                            } else if ( count_sub_checkboxes === 0 ) {
                                // No sub toggles found
                                this_parent = _this.closest( '.tgcw_settings_box' );
                                this_parent.remove();
                            }
                        }
                    });
                    break;
                // ----------------------------
                case 'set':
                    // Create some cookies!
                    tar_checkbox.each( function() {
                        let _this       = jQuery( this );
                        let this_ref    = _this.attr( 'data-ref' );
                        let is_checked  = _this.is( ':checked' );
                        let this_val 	= ( is_checked ) ? 'accept' : 'reject';
                        tgcw_cookie( task, this_ref, this_val );
                    });
                    // Add small deferred delay
                    tgcw_wait( 150 ).then( function() {
                        tgcw_reload();
                    });
                    break;
                // ----------------------------
                default:
                    return false;
            }
        }
    }

    // Cookie management
    function tgcw_cookie( task, ref, arg ) {
        if ( task && typeof task !== 'undefined' && ref && typeof ref !== 'undefined' && ref !== 'localhost' ) {
            switch( task ) {
                // Check for cookies, then return correct boolean for further processing
                case 'get':
                    let curr_cookie = Cookies.get( 'tgcw_' + ref );
                    if ( typeof curr_cookie !== 'undefined' && curr_cookie === 'accept' ) {
                        return true;
                    } else if ( typeof curr_cookie === 'undefined' || typeof curr_cookie !== 'undefined' && curr_cookie === 'reject' ) {
                        return false;
                    }
                    break;
                // ----------------------------
                // Set a cookie
                case 'set':
                    if ( arg && typeof arg !== 'undefined' ) {
                        // Some additional info on cookie attributes: https://www.invicti.com/learn/cookie-security-flags/
                        // Set the expiry date (default = 1 month from now)
                        let days            = 30;
                        // Get the current host domain
                        let current_domain  = window.location.hostname;
                        // Fallback for local development, based on secure connection set the parameter accordingly
                        let is_secure = true; // Default is true for rolled out instances that should have a valid certificate
                        if ( window.location.protocol !== 'https:' || ( current_domain === 'localhost' || current_domain === '127.0.0.1' )) {
                            is_secure = false;
                        }
                        // Set the cookie with the appropriate attributes
                        Cookies.set( 'tgcw_' + ref, arg, {
                            path: '/',
                            domain: current_domain,
                            expires: days,
                            // 'max-age': month,
                            secure: is_secure
                        });
                    }
                    break;
                // ----------------------------
                default:
                    return false;
            }
        }
    }

    // -------------------------------------------

    // Summon TGCW
    jQuery( document ).on( 'click', '.js_tgcw_recall', function( e ) {
        e.stopPropagation();
        tgcw_recall( true );
    });

    // Hide TGCW
    jQuery( document ).on( 'click', '.js_tgcw_close', function( e ) {
        e.stopPropagation();
        tgcw_recall();
    });

    // Toggle sub toggles per main panel toggle
    jQuery( document ).on( 'click', '.js_tgcw_toggle', function( e ) {
        e.stopPropagation();
        let _this           = jQuery( this );
        let this_toggle     = _this.attr( 'data-toggle' );
        let this_checked    = _this.is( ':checked' );
        let this_sub_text   = _this.closest( '.tgcw_settings_box' ).find( '.tgcw_content_toggle' );
        let this_sub_toggle = _this.closest( '.tgcw_settings_box' ).find( '.tgcw_specs_text .tgcw_checkbox' );
        // Toggle some checkboxes
        if ( this_toggle === 'main' ) {
            if ( this_checked && this_sub_toggle.length ) {
                this_sub_toggle.each( function() {
                    let _this = jQuery( this );
                    _this.prop( 'checked', true );
                });
                this_sub_text.prop( 'checked', true );
            } else if ( ! this_checked && this_sub_toggle.length ) {
                this_sub_toggle.each( function() {
                    let _this = jQuery( this );
                    _this.prop( 'checked', false );
                });
                this_sub_text.prop( 'checked', false );
            }
        } else {
            // Sub toggles
            let parent_box              = _this.closest( '.tgcw_settings_box:not( .sub )' );
            let this_main_toggle        = parent_box.find( ':checkbox[data-toggle="main"]' );
                this_sub_text           = parent_box.find( '.tgcw_content_toggle' );
            let count_sub_checkboxes    = parent_box.find( '.tgcw_settings_box.sub :checkbox' ).length;
            let checked_sub_checkboxes  = parent_box.find( '.tgcw_settings_box.sub :checkbox:checked' ).length;
            // When all sub toggles are checked, also set the main toggle to be checked
            if (( this_main_toggle.is( ':checked' ) || ! this_main_toggle.is( ':checked' )) && count_sub_checkboxes === checked_sub_checkboxes ) {
                // console.log( 'All sub settings are checked' );
                this_main_toggle.prop( 'checked', true );
                this_sub_text.prop( 'checked', true );
            } else if (( this_main_toggle.is( ':checked' ) || ! this_main_toggle.is( ':checked' )) && checked_sub_checkboxes ) {
                // console.log( 'Some sub settings are checked' );
                this_main_toggle.prop( 'checked', false );
                this_sub_text.prop( 'checked', true );
            } else if (( this_main_toggle.is( ':checked' ) || ! this_main_toggle.is( ':checked' )) && checked_sub_checkboxes === 0 ) {
                // console.log( 'No sub settings are checked' );
                this_main_toggle.prop( 'checked', false );
                this_sub_text.prop( 'checked', false );
            }
        }
    });

    // Accept / reject platform actions per main panel button
    jQuery( document ).on( 'click', '.js_tgcw_main_action', function( e ) {
        e.stopPropagation();
        let _this				= jQuery( this );
        let this_val		    = _this.attr( 'data-val' );
        let tar_checkbox        = tgcw_content.find( ':checkbox:not(:checkbox[data-ref="mandatory"])' );
        // Do stuff ...
        switch( this_val ) {
            // Check for cookie
            case 'accept_selected':
                // Just continue ...
                break;
            // ----------------------------
            case 'reject_all':
                // Iterate through all checkboxes and set to false
                tar_checkbox.each( function() {
                    let _this = jQuery( this );
                    _this.prop( 'checked', false );
                });
                break;
            // ----------------------------
            case 'accept_all':
                // Iterate through all checkboxes and set to true
                tar_checkbox.each( function() {
                    let _this = jQuery( this );
                    _this.prop( 'checked', true );
                });

                break;
            // ----------------------------
            default:
                return false;
        }
        // Add small deferred delay
        tgcw_wait( 150 ).then( function() {
            tgcw_panel_process( 'set' );
        });
    });

    // Accept / reject platform actions per wall button individually
    jQuery( document ).on( 'click', '.js_tgcw_action', function( e ) {
        e.stopPropagation();
        let _this				= jQuery( this );
        let this_parent			= _this.closest( '.tgcw_actions' );
        let this_ref		    = _this.attr( 'data-ref' );
        let this_action_type	= this_parent.attr( 'data-action_trigger' );
        let this_action;
        let this_val;
        // Is this a button or a checkbox?
        if ( this_action_type === 'buttons' ) {
            this_action = _this.attr( 'data-val' );
            this_val 	= this_action;
        } else if ( this_action_type === 'toggle' ) {
            this_action = _this.is( ':checked' );
            this_val 	= ( this_action ) ? 'accept' : 'reject';
        }
        // Trigger rebuild and set cookie ...
        if ( this_val === 'accept' ) {
            // Add small deferred delay
            tgcw_wait( 150 ).then( function() {
                // TODO: Set correct params (see lib.)
                tgcw_cookie( 'set', this_ref, this_val );
                // Go ahead and rebuild ...
                // tgcw_rebuild( this_id ); // NOTE: Using the rebuild function at this stage doesn't load the content, so a page reload needs to be triggered
                tgcw_reload();
            });
        } if ( this_val === 'reject' ) {
            // Add small deferred delay
            tgcw_wait( 150 ).then( function() {
                // TODO: Set correct params (see lib.)
                tgcw_cookie( 'set', this_ref, this_val );
            });
        }
    });

})();